import React, { useEffect } from "react";
import { orderCardStyles } from "./OrderDetailsCardStyles";

import { Body1, Body2, Divider, mergeClasses, Subtitle2 } from "@fluentui/react-components";
import { HelperUtils, useAppStore } from "../../../common";
import { CartEntry } from "../../Checkout/CartEntries/CartEntry/CartEntry";

import { OrderStatusCard } from "../OrderStatus/OrderStatusCard";
import { useParams } from "react-router-dom";
import { Pricing } from "@dining/api-client";

export const OrderDetailsCard = () => {
  const useStyles = orderCardStyles;
  const styles = useStyles();
  const { selected, setSelected, values } = useAppStore((state) => state.orders);
  const helperUtils = HelperUtils.getInstance();
  const selectedOrderText = "Your Online Order #" + selected?.orderNumber;

  const { orderId } = useParams();

  useEffect(() => {
    if (orderId) {
      const order = values?.find((order) => order?.id === orderId);
      if (order) {
        setSelected(order);
        document.title = `Order ${order?.orderNumber} - Microsoft Dining`;
      }
    }
    return () => {
      document.title = "Cafés - Microsoft Dining";
    };
  }, [orderId, values]);

  return (
    selected && (
      <div className={styles.container} data-testid="OrderDetails">
        <main className={styles.main}>
          <div className={styles.subMainContainer}>
            <OrderStatusCard order={selected} />
            <div className={styles.orderBody}>
              <Body1 className={mergeClasses(styles.reviewLine, styles.title)}>
                {selectedOrderText}
              </Body1>
              <Subtitle2 className={styles.subTitle}>Order Summary</Subtitle2>
              <div className={styles.itemList}>
                {selected?.items ? (
                  selected.items.map((item) => {
                    const dietary = helperUtils.getDietaryLabelStr(item);
                    const dietaryAccessible = helperUtils.getDietaryLabelAccessibleStr(item);
                    return (
                      <div key={`${item?.id}-container`} className={styles.itemList}>
                        <CartEntry
                          key={`${item?.id}-card`}
                          label={`${item?.name}${dietary ? " " + dietary : ""}`}
                          accessibleLabel={`${item?.name}${dietaryAccessible ? " " + dietaryAccessible : ""}`}
                          customInstructions={item.customInstruction}
                          subTitle={helperUtils.getSelectedOptionsString(item.options!)}
                          amount={helperUtils.getPricingStr(
                            Pricing.fromJS({
                              amount: item.amountWithOptions,
                              currencyUnit: item.pricing?.currencyUnit,
                            }),
                          )}
                          amountClassName={styles.itemAmount}
                        />
                        <Divider key={`${item?.id}-divider`} appearance="strong" />
                      </div>
                    );
                  })
                ) : (
                  <CartEntry key={"0"} label="Order is empty" />
                )}
                {selected?.taxAmount?.amount && (
                  <div className={styles.amountBody}>
                    <div className={styles.reviewLine}>
                      <Subtitle2>Tax</Subtitle2>
                    </div>
                    <Body2 className={mergeClasses(styles.reviewLine, styles.taxAmount)}>
                      {selected?.taxAmount?.currencyUnit
                        ? selected?.taxAmount?.currencyUnit + selected?.taxAmount?.amount.toFixed(2)
                        : ""}
                    </Body2>
                  </div>
                )}
                {selected?.taxAmount?.amount && <Divider appearance="strong" />}
                {selected?.totalAmount?.amount && (
                  <div className={styles.amountBody}>
                    <div className={styles.reviewLine}>
                      <Subtitle2>Total</Subtitle2>
                    </div>
                    <Body2 className={mergeClasses(styles.reviewLine, styles.totalAmount)}>
                      {selected?.totalAmount?.currencyUnit
                        ? selected?.totalAmount?.currencyUnit +
                          selected?.totalAmount?.amount.toFixed(2)
                        : ""}
                    </Body2>
                  </div>
                )}
              </div>
            </div>
          </div>
        </main>
      </div>
    )
  );
};
